import type {
  AccountInfo,
  OrganizationInfo,
  SubOrganizationInfo
} from '@src/endpoints/services/base.service'

export interface Account extends Omit<AccountInfo, 'account_info'> {
  account_info: string[]
}

export interface SubOrganization
  extends Omit<SubOrganizationInfo, 'account_info' | 'sub_organization'> {
  account_info: string[]
  sub_organization: string[]
}

export interface Organization
  extends Omit<OrganizationInfo, 'account_info' | 'sub_organization'> {
  account_info: string[]
  sub_organization: string[]
}

export interface AccountsSchema {
  accounts: {
    [key: string]: Account
  }
  accountsByAccountId?: { [key: string]: AccountInfo }
}
export interface SubOrganizationsSchema {
  subOrganizations: {
    [key: string]: SubOrganization
  }
}
export interface OrganizationsSchema {
  organizations: {
    [key: string]: Organization
  }
}

export interface OrganizationEntities
  extends AccountsSchema,
    SubOrganizationsSchema,
    OrganizationsSchema {
  organizationsByOrgId?: { [key: string]: Organization }
  subOrganizationsById?: { [key: string]: SubOrganization }
  accountsByOrgUID?: { [key: string]: Account[] }
}

export interface SingleAccountEntities extends AccountsSchema {}

export interface SingleAccounts {
  entities: SingleAccountEntities
  accountUIDs: string[]
  accountIds: string[]
}

export interface Organizations {
  entities: OrganizationEntities
  organizationUIDs: string[]
  organizationIds: string[]
  subOrganizationsUIDs: string[]
  subOrganizationsIds: string[]
  accountIds: string[]
  accountUIDs: string[]
}

export enum SnapshotStateEnum {
  Polling = 'POLLING',
  Normal = 'NORMAL',
  Refreshing = 'REFRESHING'
}
